import { useEffect, useState } from "react";
import { FileText, X } from "lucide-react";

import { Button } from "@/components/ui/button";

interface ImageAttachmentsPreviewProps {
 files: File[];
 onRemoveAt: (index: number) => void;
 disabled?: boolean;
}

const formatBytes = (bytes: number): string => {
 if (bytes < 1024) return `${bytes} B`;
 if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
 return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export function ImageAttachmentsPreview({ files, onRemoveAt, disabled }: ImageAttachmentsPreviewProps) {
 const [urls, setUrls] = useState<(string | null)[]>([]);

 useEffect(() => {
 // Only generate object URLs for images; documents/videos are shown with an icon + label.
 const next = files.map((f) => (f.type?.startsWith("image/") ? URL.createObjectURL(f) : null));
 setUrls(next);
 return () => {
 for (const u of next) {
 if (u) URL.revokeObjectURL(u);
 }
 };
 }, [files]);

 if (!files.length) return null;

 return (
 <div className="space-y-2">
 {files.map((file, idx) => (
 <div key={`${file.name}-${file.size}-${file.lastModified}-${idx}`} className="flex items-start gap-3 rounded-lg border p-3">
 {urls[idx] ? (
 <img
 src={urls[idx] as string}
 alt={file.name || `Attachment ${idx + 1}`}
 className="h-24 w-24 rounded object-cover border"
 />
 ) : (
 <div className="h-24 w-24 rounded border bg-muted/40 flex items-center justify-center text-muted-foreground">
 <FileText className="h-8 w-8" />
 </div>
 )}
 <div className="flex-1 min-w-0">
 <div className="text-sm font-medium truncate">{file.name || `Attachment ${idx + 1}`}</div>
 <div className="text-xs text-muted-foreground">
 {formatBytes(file.size)} - will be attached to your report.
 </div>
 </div>
 <Button
 type="button"
 variant="ghost"
 size="icon"
 onClick={() => onRemoveAt(idx)}
 disabled={disabled}
 className="shrink-0"
 >
 <X className="h-4 w-4" />
 </Button>
 </div>
 ))}
 </div>
 );
}











